import {
    useAppDisplayModeContext,
    Grid,
    useStyles,
} from '@archipro-design/aria';
import * as S from './PaginatedMagazines.style';
import type { MagazineDirectoryTileViewModel } from '../../type';
import { TileGrid } from '~/modules/category/component/tile-grid/TileGrid';
import { MagazineCard } from '../magazine-card/MagazineCard';
import { FilterSection } from '../filter-section/FilterSection';
import type { FilterStates } from '~/modules/magazine/type/filter-states';
import type { PaginationState } from '@modules/pagination/type';
import type { digitalPublicationFilters } from '../../api/digital-publication-filters.server';

interface PaginatedMagazinesProp {
    totalCount: number;
    magazineTiles: MagazineDirectoryTileViewModel[];
    pagination: PaginationState;
    initialFilterState: FilterStates;
    filters: Awaited<ReturnType<typeof digitalPublicationFilters>>;
}

export const PaginatedMagazines: React.FC<PaginatedMagazinesProp> = ({
    pagination,
    magazineTiles,
    totalCount,
    initialFilterState,
    filters,
}) => {
    const { css } = useStyles();
    const { desktop } = useAppDisplayModeContext();
    const gridColumns = desktop ? 4 : 2;

    pagination.totalCount = totalCount;

    const tiles = magazineTiles.map((magazine) => (
        <MagazineCard
            key={magazine.link}
            magazine={magazine}
            paginationState={{
                list: magazineTiles.map((a) => a.urlSegment),
                page: pagination.page,
            }}
        />
    ));

    return (
        <div className={css(S.Wrap)}>
            <Grid columns={'100%'} className={css(S.Container)}>
                {desktop && (
                    <FilterSection
                        initialStates={initialFilterState}
                        filters={filters}
                    />
                )}
                <div className={css(S.ResultSection)}>
                    <TileGrid
                        items={tiles}
                        columns={gridColumns}
                        pagination={pagination}
                        paginationItem={'Magazines'}
                    />
                </div>
            </Grid>
        </div>
    );
};
